const nonAlphanumeric = /[^a-z0-9_\s-]/;
const whitespace = /[\s-_]+/;

// lower cases, removes non alphanumeric characters and converts whitespace to dashes
export function getSearchFieldClass(fieldName: string) {
  const sanitizedName = fieldName
    .toLowerCase()
    .replace(nonAlphanumeric, '')
    .replace(whitespace, '-');
  return `fullstory-search-${sanitizedName}`;
}
